import { render, staticRenderFns } from "./FacebookIcon.vue?vue&type=template&id=18da0ac2&scoped=true"
import script from "./FacebookIcon.vue?vue&type=script&lang=js"
export * from "./FacebookIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18da0ac2",
  null
  
)

export default component.exports